<template>
  <div class="fade-in goals columns">
    <div class="column is-narrow goals-sidebar">
      <div>
        <div class="goals-header">
          <h5>{{$t('goals.phaseWheelTitle')}}</h5>
        </div>
        <div class="goals-phase-wheel-container">
          <phase-wheel class="goals-phase-wheel"></phase-wheel>
        </div>
        <div class="goals-header">
          <h5>{{$t('goals.infoIconsTitle')}}</h5>
          <br>
        </div>
        <div class="goals-sdginfos">
          <div v-for="goal in getInfoGoalList" class="goals-sdginfo" :key="goal.goalId" @click="openModal('sdg-info-modal', goal)">
            <icon :name="goal.code" class="goals-sdginfo-icon"></icon>
          </div>
        </div>
      </div>
    </div>
    <div class="column goals-main">
      <div class="goals-wheel-container">
        <div class="goals-header">
          <h5>{{$t('goals.pageSubtitle')}}</h5>
        </div>
        <div class="goals-wheel-wrapper">
          <wheel class="opacity-full" :selectedGoals="getSelectedGoals" :mode="'select'" :showGoalsImmediately="true" :view="activePageCode" :showIcons="true" :useComponentButton="'true'" ref="goalWheel" :name="'goals'"></wheel>
          <div class="sdgm-center-button-container goals-wheel-button">
            <div class="sdgm-center-button" @click="gotoTasks">{{$t('goals.buttonlabelContinue')}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import phaseWheel from './../shared/phase-wheel/phase-wheel'
import wheel from './../shared/sdg-wheel/sdg-wheel.vue'

export default {
  name: 'goals',
  components: {
    phaseWheel,
    wheel
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      activePageCode: 'getActivePageCode',
      project: 'getProject',
      profile: 'getProfile',
      profileGoals: 'getProfileGoals'
    }),
    getInfoGoalList () {
      let goalList = [...this.profileGoals]
      goalList.unshift({ code: 0, title: this.$t('goals.unInfoTitle'), description: this.$t('goals.unInfoText') })
      return goalList
    },
    getSelectedGoals () {
      return []
    }
  },
  methods: {
    ...mapActions({
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setModalData: 'setModalData',
      setActivePageCode: 'setActivePageCode'
    }),
    openModal (type, goal) {
      this.setShowModal(true)
      this.setModalType(type)
      this.setModalData({ initial: goal.code, goals: this.getInfoGoalList })
    },
    gotoTasks () {
      this.setActivePageCode('tasks')
    }
  }
}
</script>
